<template>
  <div class="career_counselling_content_block clearfix">
    <div class="photo_area">
      <div
        class="photo_img"
        :style="`background-image: url('${ counselor.counselor_avatar.length ? counselor.counselor_avatar[0].attachment_url : '/images/profile_photo.png'}')`"
      />
    </div>
    <div class="content_area">
      <div class="title_area clearfix">
        <div class="name float-left">
          {{ counselor.counselor_name }}
        </div>
        <div class="company float-left">
          {{ counselor.counselor_word_for }}
        </div>
        <div class="title float-left">
          {{ counselor.counselor_title }}
        </div>
      </div>
      <career-counselling-card-form
        :counselor="counselor"
        :title-ch="titleCh"
        :title-en="titleEn"
      >
        <router-link
          :to="`/career-counselling/${counselorType}/${counselor.counselor_id}`"
          class="detail_bt"
        >
          詳細內容
        </router-link>
      </career-counselling-card-form>
    </div>
  </div>
</template>
<script>
import CareerCounsellingCardForm from './CareerCounsellingCardForm'
export default {
  name: 'CareerCounsellingCard',
  components: {
    CareerCounsellingCardForm
  },
  props: {
    counselor: {
      type: Object,
      required: true
    },
    counselorType: {
      type: String,
      default: 'career-counselors',
      validator: value => 'career-counselors' || 'industry-mentors'
    },
    titleCh: {
      type: String,
      default: ''
    },
    titleEn: {
      type: String,
      default: ''
    }
  }
}
</script>
